import angular from 'angular';
import components from './components';

export default angular.module('adviserAccreditationTabs.scenes', [components])
  .name;
